import battle_s from "@/assets/images/pk/battle_s.png"
import arenePk from "@/assets/images/pk/arenePk.png"
import people from "@/assets/images/pk/people.png"
import times from "@/assets/images/pk/times.png"
import arena_1 from "@/assets/images/pk/arena_1.png"
import arena_2 from "@/assets/images/pk/arena_2.png"
import pk from "@/assets/images/pk/pk.png"
import Arena_PK_zh from "@/assets/images/pk/Arena_PK_zh.png"
import Arena_PK from "@/assets/images/pk/Arena_PK.png"
import power_bg from '@/assets/images/attribute/power_bg.png'
import Battle_text_zh from "@/assets/images/pk/Battle_text_zh.png"
import Battle_text from "@/assets/images/pk/Battle_text.png"
import { getBattleDeck, getApexRank } from "@/api/pk_url.js"
import { Toast } from "react-vant"
import { useEffect, useState } from "react"
import { attributeImage, formatNumber } from "../../utils"
import { useNavigate } from "react-router-dom"
import { changeLoginState } from "../../store/module/h5Login"
import { useDispatch } from "react-redux"
import PromptDialog from "../../components/PromptDialog"
import { useTranslation } from "react-i18next";
import BattleHomeGuide from "../../components/guide/BattleHomeGuide"
import { useSelector } from "react-redux"

const BattleHome = () => {
  const { t, i18n } = useTranslation();
  const [data, getData] = useState<any>(null)
  const dispatch = useDispatch()
  const guideType = useSelector((state: any) => state.tabbar.guideType)
  const userInfo = useSelector((state: any) => state.tabbar.userInfo)
  const [apexRank, setApexRank] = useState<any>({})
  const { isShowIntroductory } = useSelector((state: any) => state.settings)
  const guideTypeList = useSelector((state: any) => state.progress.guideTypeList)
  const dataStatistics = useSelector((state: any) => state.progress.dataStatistics)
  const navigate = useNavigate()
  const [keys, setKeys] = useState([
    'character_card',
    'nft_card',
    'diamond_card',
    'gold_card',
    'silver_card',
    'bronze_card',
  ])
  const gatMyDeck = async () => {
    const toast = Toast.loading({
      message: t("other.loading"),
      forbidClick: true,
      duration: 0
    });
    try {
      const res = await getApexRank(0, 5, 0)
      if (res.code == '0') {
        setApexRank(res.data)
      }
      const { data, code } = await getBattleDeck(0)
      toast.clear()
      if (code == '0') {
        let obj: any = {}
        keys.map((el: any) => {
          if (data[el]) {
            if (el != 'character_card') {
              obj[el] = data[el].type ? data[el].character_card_item : data[el].normal_card_item
            } else {
              obj[el] = data[el]
            }
          } else {
            obj[el] = null
          }
        })
        obj.power = data.power
        getData(obj)
      }
    } catch {
      toast.clear()
    }
  }
  useEffect(() => {
    gatMyDeck()
  }, [])

  const [apexData, getApexDat] = useState<any>({})
  const [isCreate, setCreate] = useState<any>(false)
  const [promptText, setPromptText] = useState<any>('')

  const apexRankFunc = async () => {
    try {
      const { data, code } = await getApexRank(0, 10, 1)
      if (code == '0') {
        getApexDat(data)
      }
    } catch (e) {
      console.error('ApexRank error:', e)
    }
  }

  useEffect(() => {
    apexRankFunc()
  }, [])

  return (
    <div className="pt-[70px] h-[calc(100vh_-_255px)] overflow-auto">
      <div onClick={() => {
        if (localStorage.getItem('token')) {
          if (apexData?.season_state == 1) {
            navigate(`/peaks-battle`)
          } else {
            setCreate(true)
            setPromptText(t("pk.the_new_season"))
          }
        } else {
          dispatch(changeLoginState(true))
          setCreate(true)
          setPromptText(t("pk.the_new_season"))
        }
      }} className=" w-full mb-[10px] relative px-4">
        {apexRank?.season_info?.name ?
          <div className="p-[10px] z-30 absolute top-0 right-4 text-[14px] leading-[18px] text-[#fff] flex justify-center items-center " style={{ background: 'linear-gradient( 135deg, #FB5445 0%, #FBB11B 100%)', borderRadius: '0px 13px 0 20px' }}>
            {apexRank?.season_info?.name} {t("pk.season")}
          </div>
          :
          <div className="p-[10px] z-30 absolute top-0 right-4 text-[14px] leading-[18px] text-[#fff] flex justify-center items-center " style={{ background: 'linear-gradient( 135deg, #FB5445 0%, #FBB11B 100%)', borderRadius: '0px 13px 0 20px' }}>
            {t("pk.off_season")}
          </div>
        }
        <div className=" absolute w-[calc(100%_-_32px)] p-[10px]">
          <div className=" flex items-center">
            <img className="w-[22px] h-[22px]" src={pk} alt="" />
            <p className="text-style-1 text-[20px] ml-1 leading-6 font-bold">{t("pk.peaks_battle")}</p>
          </div>
          <div className=" flex justify-center gap-6 mt-10 items-center">
            <div className="flex items-center">
              <p className="text-style-1 text-[24px] ml-1 leading-6 font-bold">{dataStatistics?.apexPkUserTotalAll ? formatNumber(dataStatistics?.apexPkUserTotalAll) : '-'}</p>
              <img className="w-[22px] h-[22px] ml-[6px]" src={people} alt="" />
            </div>
            <div className="flex items-center">
              <p className="text-style-1 text-[24px] ml-1 leading-6 font-bold">{dataStatistics?.apexPkStatItemAll ? formatNumber(dataStatistics?.apexPkStatItemAll) : '-'}</p>
              <img className="w-[22px] h-[22px] ml-[6px]" src={times} alt="" />
            </div>
          </div>
          <div className=" flex items-center justify-center flex-col mt-[31px]">
            <p className=" text-[14px] leading-[18px] text-[#FFFFFF] font-bold">
              {t("create_arena.challenge")}, {t("create_arena.get_ranking")}
            </p>
            <p className="text-[14px] leading-[18px] text-[#FFFFFF] font-bold">
              {t("create_arena.get_season")}
            </p>
          </div>
        </div>
        <img src={arenePk} alt="" />
      </div>

      <div onClick={() => {
        navigate('/arena-Pk')
      }} className=" w-full mb-[10px] relative px-4">
        <div className=" absolute w-[calc(100%_-_32px)] p-[10px]">
          <div className=" flex items-center">
            <img className="w-[22px] h-[22px]" src={arena_1} alt="" />
            <p className="text-style-1 text-[20px] ml-1 leading-6 font-bold">{t("pk.arena_PK")}</p>
          </div>
          <div className=" flex justify-center gap-6 mt-[30px] items-center">
            <div className="flex items-center">
              <p className="text-style-1 text-[24px] ml-1 leading-6 font-bold">{dataStatistics?.pkUserTotal ? formatNumber(dataStatistics?.pkUserTotal) : '-'}</p>
              <img className="w-[22px] h-[22px] ml-[6px]" src={people} alt="" />
            </div>
            <div className="flex items-center">
              <p className="text-style-1 text-[24px] ml-1 leading-6 font-bold">{dataStatistics?.pkArenasTotal ? formatNumber(dataStatistics?.pkArenasTotal) : '-'}</p>
              <img className="w-[22px] h-[22px] ml-[6px]" src={times} alt="" />
            </div>
          </div>
          <div className=" flex items-center justify-center mt-[10px]">
            <p className="text-style-1 text-[24px] ml-1 leading-[29px] font-bold">{dataStatistics?.pkTotal ? formatNumber(dataStatistics?.pkTotal) : '-'}</p>
            <img className="w-[22px] h-[22px] ml-[6px]" src={arena_2} alt="" />
          </div>
          <div className=" flex items-center justify-center flex-col mt-[30px]">
            <p className=" text-[14px] leading-[18px] text-[#FFFFFF] font-bold">
              {t("create_arena.create_arena")}, {t("create_arena.set_bets")},{t("create_arena.win_Rewards")}
            </p>
          </div>
        </div>
        <img src={battle_s} alt="" />
      </div>

      <div onClick={() => {
        if (localStorage.getItem('token')) {
          navigate('/my-deck?id=0')
        } else {
          dispatch(changeLoginState(true))
        }
      }}
        style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }}
        className="px-[5px] flex justify-between pt-[23px] pb-[10px] w-[calc(100%_-_32px)] md:absolute fixed bottom-[130px] ml-4 h-[93px]">
        <div className="px-[10px] py-1 absolute top-[-13px]" style={{ background: '#113A38', borderRadius: '10px 10px 0px 0px' }}>
          <p className="text-style-1 text-[14px] leading-[18px] font-bold">{t("pk.my_deck")}</p>
        </div>
        {data ? 
        <div className=" flex gap-[5px]">
          {keys.map((el: string) =>
            <>
              {data[el] ?
                <div key={data[el].id} className=" w-10 h-[60px] bg-[rgb(255,255,255,0.5)] rounded-[10px] relative flex justify-center items-center">
                  <img className=" rounded-[10px]" src={data[el].image} alt="" />
                  <img className={` absolute top-0 left-0 w-[13px] h-[13px]`} src={attributeImage(data[el].property)} alt="" />
                  <div className=" absolute z-10 w-[36px] h-[16px] flex justify-center items-center">
                    <img className="absolute" src={power_bg} alt="" />
                    <p className={`${data[el].bonus_power ? 'text-style-6' : 'text-style-1'} relative z-10 text-[12px] leading-[15px] font-bold`}>{data[el].power + data[el].bonus_power}</p>
                  </div>
                </div> :
                <div className=" w-10 h-[60px] bg-[rgb(255,255,255,0.5)] rounded-[10px] flex justify-center items-center" key={el}>
                  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <g id="优化页面" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="03-PK页主" transform="translate(-74.000000, -629.000000)" fill="#FFFFFF" fillRule="nonzero">
                        <g id="编组-4备份-2" transform="translate(16.000000, 575.000000)">
                          <g id="编组备份-3" transform="translate(58.000000, 54.000000)">
                            <path d="M22.8313043,13 L1.16869567,13 C0.525913044,13 0,12.55 0,12 C0,11.45 0.525913044,11 1.16869567,11 L22.8313043,11 C23.474087,11 24,11.45 24,12 C24,12.55 23.474087,13 22.8313043,13 Z" id="路径"></path>
                            <path d="M11,22.8313044 L11,1.16869564 C11,0.525913018 11.45,0 12,0 C12.55,0 13,0.525913045 13,1.16869564 L13,22.8313044 C13,23.474087 12.55,24 12,24 C11.45,24 11,23.474087 11,22.8313044 L11,22.8313044 Z" id="路径"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              }
            </>
          )}
        </div> :
          <>
            {keys.map((el: string) =>
              <div className=" w-10 h-[60px] bg-[rgb(255,255,255,0.5)] rounded-[10px] flex justify-center items-center" key={el}>
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <g id="优化页面" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="03-PK页主" transform="translate(-74.000000, -629.000000)" fill="#FFFFFF" fill-rule="nonzero">
                      <g id="编组-4备份-2" transform="translate(16.000000, 575.000000)">
                        <g id="编组备份-3" transform="translate(58.000000, 54.000000)">
                          <path d="M22.8313043,13 L1.16869567,13 C0.525913044,13 0,12.55 0,12 C0,11.45 0.525913044,11 1.16869567,11 L22.8313043,11 C23.474087,11 24,11.45 24,12 C24,12.55 23.474087,13 22.8313043,13 Z" id="路径"></path>
                          <path d="M11,22.8313044 L11,1.16869564 C11,0.525913018 11.45,0 12,0 C12.55,0 13,0.525913045 13,1.16869564 L13,22.8313044 C13,23.474087 12.55,24 12,24 C11.45,24 11,23.474087 11,22.8313044 L11,22.8313044 Z" id="路径"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>)}
          </>
        }
        {data && data.power ?
          <div className=" justify-center flex items-center flex-col">
            <p className="mt-[3px] text-[19px] leading-[22px] text-[#fff] font-semibold">{data.power}</p>
            <p className="mt-[9px] text-[12px] leading-[19px] text-[#fff] font-semibold">{t("deck_configuration.total_power")}</p>
          </div> :
          <div className=" justify-center flex items-center flex-col">
            <p className="mt-[3px] text-[19px] leading-[22px] text-[#fff] font-semibold">0</p>
            <p className="mt-[9px] text-[12px] leading-[19px] text-[#fff] font-semibold">{t("deck_configuration.total_power")}</p>
          </div>
        }
      </div>
      <PromptDialog
        lineBreak={true}
        title={t("other.attention") as string}
        dialog={isCreate}
        setDialog={setCreate}
        text={promptText}
      ></PromptDialog>
      {!guideTypeList.status && guideType && !guideTypeList.tasks.pkHomeGuide && <BattleHomeGuide></BattleHomeGuide>}
    </div>
  )
}
export default BattleHome

